import React, { useEffect, useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { API_BASE } from "../api/apiConfig";
import { fetchgrouptripstour } from "../services/Grouptripstourlist"; // your API call

import CommonSection from '../Components/CommonSection';


const GroupTrips = () => {
  const [showFilters, setShowFilters] = useState(false);

  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filters, setFilters] = useState({
    destinations: [],
    months: [],
    budgets: [],
    categories: [],
  });
  
  const [searchTerm, setSearchTerm] = useState("");
  const [accordionStates, setAccordionStates] = useState([true, true, true, true]);
  const [selectedFilters, setSelectedFilters] = useState({
    destination: "All",
    month: "All Months",
    budget: "All Budgets",
    category: "All",
  });


  useEffect(() => {
    const loadTrips = async () => {
      const res = await fetchgrouptripstour(); // fetch trips from API
      if (res?.status && res?.data) {
        setTrips(res.data);

        // Extract unique filter values dynamically
        const destinations = ["All", ...new Set(res.data.map((t) => t.city))];
        const months = ["All Months", ...new Set(res.data.flatMap((t) => t.months))]; // if your data has `months` array
        const budgets = ["All Budgets", "Budget Friendly", "Moderate", "Premium"];
        const categories = ["All", ...new Set(res.data.map((t) => t.category))];

        setFilters({ destinations, months, budgets, categories });
      }
      setLoading(false);
    };
    loadTrips();
  }, []);

  const toggleSection = (index) => {
    setAccordionStates((prev) => {
      const newStates = [...prev];
      newStates[index] = !newStates[index];
      return newStates;
    });
  };

  // Filter trips based on selected filters
  const filteredTrips = trips.filter((trip) => {
    return (
      // 🔍 SEARCH
      (searchTerm === "" ||
        (trip.name || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        (trip.city || "").toLowerCase().includes(searchTerm.toLowerCase())
      ) &&

      // 📍 DESTINATION
      (selectedFilters.destination === "All" || trip.city === selectedFilters.destination) &&

      // 📅 MONTH (from tour_date)
      (selectedFilters.month === "All Months" ||
        (() => {
          try {
            const dates = trip.tour_date ? JSON.parse(trip.tour_date) : [];

            return dates.some((date) => {
              const cleanDate = date.split("-")[0].trim(); // "21 Jan"
              const monthShort = cleanDate.split(" ")[1]; // "Jan"

              const monthMap = {
                January: "Jan",
                February: "Feb",
                March: "Mar",
                April: "Apr",
                May: "May",
                June: "Jun",
                July: "Jul",
                August: "Aug",
                September: "Sep",
                October: "Oct",
                November: "Nov",
                December: "Dec",
              };

              return monthShort === monthMap[selectedFilters.month];
            });
          } catch {
            return false;
          }
        })()
      ) &&

      // 💰 BUDGET
      (selectedFilters.budget === "All Budgets" ||
        (selectedFilters.budget === "Budget Friendly" && trip.charges <= 25000) ||
        (selectedFilters.budget === "Moderate" && trip.charges > 25000 && trip.charges <= 40000) ||
        (selectedFilters.budget === "Premium" && trip.charges > 40000)
      ) &&
    // 🏷 CATEGORY ✅ (YAHI ADD KARNA THA)
    (selectedFilters.category === "All" ||
      trip.categorydata?.toLowerCase() === selectedFilters.category.toLowerCase())
    );
  });

  return (
    <>
      <Header />
     
     <div className='hidden sm:block'>
      <main className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50">
        {/* Hero Section */}
        <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
          <div className="absolute inset-0 z-0">
            <img
              alt="Group Travel Adventures"
              decoding="async"
              className="object-cover object-center opacity-40"
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                inset: 0,
                color: "transparent"
              }}
              src="/assets/images/group-travel-adventure-mountains.jpg"
            />
            <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-transparent to-secondary/20" />
          </div>
          <div className="container relative z-10 mx-auto px-4 py-16 md:py-20 text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2 mb-6 backdrop-blur-md border border-white/20">
              <div className="h-2 w-2 rounded-full bg-green-400 animate-pulse" />
              <span className="text-sm font-medium text-white">
                Join 10,000+ Happy Travelers
              </span>
            </div>
            <h1 className="font-bold text-white mb-4 leading-tight text-4xl md:text-5xl lg:text-6xl">
              Discover Your Next
              <span className="block bg-gradient-to-r from-white via-blue-100 to-purple-100 bg-clip-text text-transparent mt-2">
                Group Adventure
              </span>
            </h1>
            <p className="text-white/80 mb-8 leading-relaxed text-base md:text-lg max-w-2xl mx-auto">
              Connect with fellow travelers and explore breathtaking destinations
              together. From mountain treks to beach escapes, find your perfect
              group trip.
            </p>
            <div className="grid grid-cols-3 gap-4 max-w-lg mx-auto">
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-4">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1">50+</div>
                <div className="text-xs md:text-sm text-white/70">Destinations</div>
              </div>
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-4">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1">10K+</div>
                <div className="text-xs md:text-sm text-white/70">Happy Travelers</div>
              </div>
              <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-4">
                <div className="text-2xl md:text-3xl font-bold text-white mb-1">200+</div>
                <div className="text-xs md:text-sm text-white/70">Group Trips</div>
              </div>
            </div>
          </div>
        </section>

        {/* Main Section */}
        <section className="py-8 bg-white border-b border-slate-200">
          <div className="container mx-auto px-4">
            {/* Filter Header */}
            <div className="mb-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="h-8 w-8 rounded-lg bg-primary/10 flex items-center justify-center">
                  {/* Map Pin Icon */}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="lucide lucide-map-pin h-4 w-4 text-primary"
                  >
                    <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                    <circle cx={12} cy={10} r={3} />
                  </svg>
                </div>
                <div>
                  <h3 className="text-base font-semibold text-slate-900">Filter by Destination</h3>
                  <p className="text-xs text-slate-500">Select your preferred travel location</p>
                </div>
              </div>
              {/* Destination Buttons */}
              <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-2">
                {filters.destinations.map((dest) => (
                    <button
                      key={dest}
                      onClick={() => setSelectedFilters((prev) => ({ ...prev, destination: dest }))}
                      className={`px-4 py-2 rounded-lg text-sm font-medium ${
                        selectedFilters.destination === dest
                          ? "bg-gradient-to-r from-primary to-primary/90 text-white shadow-md"
                          : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                      }`}
                    >
                      {dest}
                    </button>
                  ))}
              </div>
            </div>

            {/* Accordion Sections */}
            <div className="flex flex-col lg:flex-row gap-6">
              {/* Left Sidebar Filters */}
              <div className="lg:w-64 space-y-3">
                {/* Search Trips */}
                <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
                  <button
                    onClick={() => toggleSection(0)}
                    className="w-full flex items-center justify-between p-3 hover:bg-slate-50 transition-colors"
                  >
                    <div className="flex items-center gap-2">
                      {/* Search Icon */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-search h-4 w-4 text-primary"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <path d="m21 21-4.3-4.3" />
                      </svg>
                      <h3 className="text-sm font-semibold text-slate-900">Search Trips</h3>
                    </div>
                    {/* Chevron Icon */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={`lucide lucide-chevron-down h-4 w-4 text-slate-500 transition-transform duration-200 ${accordionStates[0] ? 'rotate-180' : ''}`}
                    >
                      <path d="m6 9 6 6 6-6" />
                    </svg>
                  </button>
                  {accordionStates[0] && (
                    <div className="px-3 pb-3">
                      {/* Search Input */}
                      <div className="relative">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-search absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400"
                        >
                          <circle cx={11} cy={11} r={8} />
                          <path d="m21 21-4.3-4.3" />
                        </svg>
                        <input
                          className="flex w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pl-10 h-9 text-sm border-slate-200 focus:border-primary focus:ring-primary/20"
                          placeholder="Search trips..."
                          type="text"
                          defaultValue="" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                        />
                      </div>
                    </div>
                  )}
                </div>

                {/* Travel Month */}
                <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
                  <button
                    onClick={() => toggleSection(1)}
                    className="w-full flex items-center justify-between p-3 hover:bg-slate-50 transition-colors"
                  >
                    <div className="flex items-center gap-2">
                      {/* Calendar Icon */}
                      <div className="h-7 w-7 rounded-lg bg-primary/10 flex items-center justify-center">
                        {/* Calendar SVG */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                        >
                          <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                          <line x1={16} x2={16} y1={2} y2={6} />
                          <line x1={8} x2={8} y1={2} y2={6} />
                          <line x1={3} x2={21} y1={10} y2={10} />
                        </svg>
                      </div>
                      <h3 className="text-sm font-semibold text-slate-900">Travel Month</h3>
                    </div>
                    {/* Chevron */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={`lucide lucide-chevron-down h-4 w-4 text-slate-500 transition-transform duration-200 ${accordionStates[1] ? 'rotate-180' : ''}`}
                    >
                      <path d="m6 9 6 6 6-6" />
                    </svg>
                  </button>
                  {accordionStates[1] && (
                    <div className="px-3 pb-3 space-y-1.5">
                      {/* Months Buttons */}
                      <button
                        onClick={() =>
                          setSelectedFilters((prev) => ({ ...prev, month: "All Months" }))
                        }
                        className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                          selectedFilters.month === "All Months"
                            ? "bg-gradient-to-r from-primary to-primary/90 text-white shadow-sm"
                            : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                        }`}
                      >
                        All Months
                      </button>
                      {['January','February','March','April','May','June','July','August','September','October','November','December'].map((month) => (
                        <button
                          key={month}
                          onClick={() =>
                            setSelectedFilters((prev) => ({ ...prev, month }))
                          }
                          className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                            selectedFilters.month === month
                              ? "bg-primary text-white"
                              : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                          }`}
                        >
                          {month}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                {/* Budget Range */}
                <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
                  <button
                    onClick={() => toggleSection(2)}
                    className="w-full flex items-center justify-between p-3 hover:bg-slate-50 transition-colors"
                  >
                    <div className="flex items-center gap-2">
                      {/* Budget Icon */}
                      <div className="h-7 w-7 rounded-lg bg-green-50 flex items-center justify-center">
                        {/* Rupee SVG */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-indian-rupee h-3.5 w-3.5 text-green-600"
                        >
                          <path d="M6 3h12" />
                          <path d="M6 8h12" />
                          <path d="m6 13 8.5 8" />
                          <path d="M6 13h3" />
                          <path d="M9 13c6.667 0 6.667-10 0-10" />
                        </svg>
                      </div>
                      <h3 className="text-sm font-semibold text-slate-900">Budget Range</h3>
                    </div>
                    {/* Chevron */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={`lucide lucide-chevron-down h-4 w-4 text-slate-500 transition-transform duration-200 ${accordionStates[2] ? 'rotate-180' : ''}`}
                    >
                      <path d="m6 9 6 6 6-6" />
                    </svg>
                  </button>
                  {accordionStates[2] && (
                    <div className="px-3 pb-3 space-y-1.5">
                      <button
                        onClick={() =>
                          setSelectedFilters((prev) => ({ ...prev, budget: "All Budgets" }))
                        }
                        className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
                          selectedFilters.budget === "All Budgets"
                            ? "bg-gradient-to-r from-green-500 to-green-600 text-white shadow-sm"
                            : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span>All Budgets</span>
                        </div>
                      </button>

                      {/* Budget Friendly */}
                      <button
                        onClick={() =>
                          setSelectedFilters((prev) => ({ ...prev, budget: "Budget Friendly" }))
                        }
                        className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                          selectedFilters.budget === "Budget Friendly"
                            ? "bg-green-500 text-white"
                            : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span>Budget Friendly</span>
                          <span className="text-xs opacity-80">₹0K - ₹25K</span>
                        </div>
                      </button>

                      {/* Moderate */}
                      <button
                        onClick={() =>
                          setSelectedFilters((prev) => ({ ...prev, budget: "Moderate" }))
                        }
                        className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                          selectedFilters.budget === "Moderate"
                            ? "bg-green-500 text-white"
                            : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span>Moderate</span>
                          <span className="text-xs opacity-80">₹25K - ₹40K</span>
                        </div>
                      </button>

                      {/* Premium */}
                      <button
                        onClick={() =>
                          setSelectedFilters((prev) => ({ ...prev, budget: "Premium" }))
                        }
                        className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                          selectedFilters.budget === "Premium"
                            ? "bg-green-500 text-white"
                            : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <span>Premium</span>
                          <span className="text-xs opacity-80">₹40K+</span>
                        </div>
                      </button>
                    </div>

                  )}
                </div>

                {/* Trip Category */}
                <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
                  <button
                    onClick={() => toggleSection(3)}
                    className="w-full flex items-center justify-between p-3 hover:bg-slate-50 transition-colors"
                  >
                    <div className="flex items-center gap-2">
                      <div className="h-7 w-7 rounded-lg bg-purple-50 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-tag h-3.5 w-3.5 text-purple-600"
                        >
                          <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                          <path d="M7 7h.01" />
                        </svg>
                      </div>
                      <h3 className="text-sm font-semibold text-slate-900">Trip Category</h3>
                    </div>

                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className={`lucide lucide-chevron-down h-4 w-4 text-slate-500 transition-transform duration-200 ${
                        accordionStates[3] ? "rotate-180" : ""
                      }`}
                    >
                      <path d="m6 9 6 6 6-6" />
                    </svg>
                  </button>

                  {accordionStates[3] && (
                    <div className="px-3 pb-3 space-y-1.5">

                      {/* All */}
                      <button
                        onClick={() =>
                          setSelectedFilters((prev) => ({ ...prev, category: "All" }))
                        }
                        className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                          selectedFilters.category === "All"
                            ? "bg-purple-500 text-white shadow-sm"
                            : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                        }`}
                      >
                        All
                      </button>

                      {/* Adventure */}
                      <button
                        onClick={() =>
                          setSelectedFilters((prev) => ({ ...prev, category: "Adventure" }))
                        }
                        className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                          selectedFilters.category === "Adventure"
                            ? "bg-purple-500 text-white"
                            : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                        }`}
                      >
                        Adventure
                      </button>

                      {/* Nature */}
                      <button
                        onClick={() =>
                          setSelectedFilters((prev) => ({ ...prev, category: "Nature" }))
                        }
                        className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                          selectedFilters.category === "Nature"
                            ? "bg-purple-500 text-white"
                            : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                        }`}
                      >
                        Nature
                      </button>

                      {/* Beach */}
                      <button
                        onClick={() =>
                          setSelectedFilters((prev) => ({ ...prev, category: "Beach" }))
                        }
                        className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                          selectedFilters.category === "Beach"
                            ? "bg-purple-500 text-white"
                            : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                        }`}
                      >
                        Beach
                      </button>

                      {/* Cultural */}
                      <button
                        onClick={() =>
                          setSelectedFilters((prev) => ({ ...prev, category: "Cultural" }))
                        }
                        className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                          selectedFilters.category === "Cultural"
                            ? "bg-purple-500 text-white"
                            : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                        }`}
                      >
                        Cultural
                      </button>

                      {/* Luxury */}
                      <button
                        onClick={() =>
                          setSelectedFilters((prev) => ({ ...prev, category: "Luxury" }))
                        }
                        className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                          selectedFilters.category === "Luxury"
                            ? "bg-purple-500 text-white"
                            : "bg-slate-50 text-slate-700 hover:bg-slate-100"
                        }`}
                      >
                        Luxury
                      </button>

                    </div>
                  )}
                </div>

                {/* Slider Info */}
                <div className="bg-gradient-to-br from-primary/10 via-primary/5 to-transparent rounded-lg border border-primary/20 p-4">
                  <div className="flex items-center gap-3">
                    <div className="h-9 w-9 rounded-lg bg-primary/20 flex items-center justify-center">
                      {/* Slider Icon SVG */}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-sliders h-4 w-4 text-primary"
                      >
                        <line x1={4} x2={4} y1={21} y2={14} />
                        <line x1={4} x2={4} y1={10} y2={3} />
                        <line x1={12} x2={12} y1={21} y2={12} />
                        <line x1={12} x2={12} y1={8} y2={3} />
                        <line x1={20} x2={20} y1={21} y2={16} />
                        <line x1={20} x2={20} y1={12} y2={3} />
                        <line x1={2} x2={6} y1={14} y2={14} />
                        <line x1={10} x2={14} y1={8} y2={8} />
                        <line x1={18} x2={22} y1={16} y2={16} />
                      </svg>
                    </div>
                    <div>
                      <p className="text-xl font-bold text-slate-900">{filteredTrips.length}</p>
                      <p className="text-xs text-slate-600">Trips available</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Main Trip Cards */}
              <div className="flex-1">
                <div className="grid gap-5 sm:grid-cols-2">
                   
              {loading ? (
                <p className="text-center col-span-2">Loading trips...</p>
              ) : filteredTrips.length === 0 ? (
                <p className="text-center col-span-2">No trips found.</p>
              ) : (
                filteredTrips.map((trip) => (
                  
                    <div key={trip.id}
                      className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/40 hover:shadow-xl reveal-on-scroll revealed"
                      style={{ transitionDelay: "450ms" }}
                    >
                      <a href={`/GroupTripsDtl/${trip.id}`}>
                        <div className="relative h-52 w-full overflow-hidden">
                          <img
                            alt={trip.name}
                            loading="lazy"
                            decoding="async"
                            data-nimg="fill"
                            className="object-cover transition-transform duration-500 group-hover:scale-110"
                            style={{
                              position: "absolute",
                              height: "100%",
                              width: "100%",
                              inset: 0,
                              color: "transparent"
                            }}
                            src={
                              trip.images
                                ? `${API_BASE}${trip.images}`
                                : `${API_BASE}default.jpg`
                            }
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                        {trip.tage && (
                          <div className="absolute top-3 left-3 flex gap-2">
                            <div className="rounded-lg bg-gradient-to-r from-primary to-primary/90 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                              <p className="flex items-center gap-1.5 text-xs font-semibold text-white">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-tag h-3.5 w-3.5"
                                >
                                  <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                  <path d="M7 7h.01" />
                                </svg>
                                {trip.tage}
                              </p>
                            </div>
                          </div>
                        )}
                          <div className="absolute top-3 right-3">
                            <div className="rounded-lg bg-white/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                              <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                                >
                                  <rect
                                    width={18}
                                    height={18}
                                    x={3}
                                    y={4}
                                    rx={2}
                                    ry={2}
                                  />
                                  <line x1={16} x2={16} y1={2} y2={6} />
                                  <line x1={8} x2={8} y1={2} y2={6} />
                                  <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                {trip.duration} / {trip.no_of_days} days
                              </p>
                            </div>
                          </div>
                          <div className="absolute bottom-0 left-0 right-0 p-4">
                            <div className="flex items-center gap-2 mb-2">
                            {trip.categorydata && (
                              <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                {trip.categorydata}
                              </div>
                            )}
                            {trip.difficulty && (
                              <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                {trip.difficulty}
                              </div>
                            )}
                            </div>
                            <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-200 transition-colors line-clamp-2">
                              {trip.name}
                            </h3>
                            <div className="flex items-center justify-between text-xs text-white/90">
                              <div className="flex items-center gap-1.5">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-map-pin h-3.5 w-3.5 text-blue-300"
                                >
                                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                  <circle cx={12} cy={10} r={3} />
                                </svg>
                                <span className="font-medium">{trip.city}</span>
                              </div>
                              <div className="flex items-center gap-1">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                                >
                                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                </svg>
                                <span className="font-semibold">4.8</span>
                                <span className="text-white/70">(124)</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="p-4">
                          <div className="flex items-center justify-between mb-3">
                            <div className="flex items-baseline gap-2">
                              <span className="text-xl font-bold text-slate-900">
                                ₹{trip.charges}
                              </span>
                              <span className="text-sm text-slate-500 line-through">
                                ₹{trip.difficulties}
                              </span>
                            </div>
                            <span className="text-xs font-bold text-green-700 bg-green-100 px-2.5 py-1 rounded-lg">
                              Save ₹{trip.difficulties - trip.charges}
                            </span>
                          </div>
                      {trip.spots && (
                          <div className="mb-3 rounded-lg bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200 px-3 py-2 text-xs font-semibold text-orange-700 flex items-center gap-2">
                            <div className="h-2 w-2 rounded-full bg-orange-500 animate-pulse"></div>
                            Only {trip.spots} spots left!
                          </div>
                      )}
                          <div className="flex items-start gap-2 text-slate-600">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-calendar h-4 w-4 text-primary mt-0.5 flex-shrink-0"
                            >
                              <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                              <line x1={16} x2={16} y1={2} y2={6} />
                              <line x1={8} x2={8} y1={2} y2={6} />
                              <line x1={3} x2={21} y1={10} y2={10} />
                            </svg>
                            <div className="flex flex-wrap gap-1.5">
                                {(() => {
                                let tourDates = [];

                                try {
                                  tourDates = trip?.tour_date
                                    ? JSON.parse(trip.tour_date)
                                    : [];
                                } catch (e) {
                                  tourDates = [];
                                }

                                return (
                                  <>
                                    {tourDates.slice(0, 3).map((date, index) => {
                                      // Remove weekday (Tuesday / Friday)
                                      const cleanDate = date.split("-")[0].trim();

                                      return (
                                        <span
                                          key={index}
                                          className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md"
                                        >
                                          {cleanDate}
                                        </span>
                                      );
                                    })}

                                    {tourDates.length > 3 && (
                                      <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                        +{tourDates.length - 3} more
                                      </span>
                                    )}
                                  </>
                                );
                              })()}
                              </div>
                          </div>
                        </div>
                      </a>
                    </div>
              ))
              )}

                    
                  </div>
              </div>
            </div>
          </div>
        </section>

        

        {/* New Html code */}
         <section className="py-12 md:py-16 bg-white">
                <div className="container mx-auto px-4 md:px-6">
                  <div className="text-center mb-8 md:mb-12 reveal-on-scroll revealed">
                    <h2 className="mb-3 text-2xl md:text-3xl font-bold text-slate-800">
                      Why Choose <span className="text-gradient">Group Trips?</span>
                    </h2>
                    <p className="text-slate-600 max-w-2xl mx-auto">
                      Travel with confidence and make lifelong friends on our carefully
                      curated group adventures
                    </p>
                  </div>
                  <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
                    <div
                      className="rounded-lg border bg-card text-card-foreground shadow-sm p-6 text-center hover:shadow-md transition-all duration-300 reveal-on-scroll revealed"
                      style={{ transitionDelay: "0ms" }}
                    >
                      <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-users h-8 w-8 text-primary"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <circle cx={9} cy={7} r={4} />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                      </div>
                      <h3 className="mb-2 text-lg font-medium text-slate-800">
                        Meet Like-Minded People
                      </h3>
                      <p className="text-sm text-slate-600">
                        Connect with fellow travelers who share your passion for exploration
                      </p>
                    </div>
                    <div
                      className="rounded-lg border bg-card text-card-foreground shadow-sm p-6 text-center hover:shadow-md transition-all duration-300 reveal-on-scroll revealed"
                      style={{ transitionDelay: "100ms" }}
                    >
                      <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-tag h-8 w-8 text-primary"
                        >
                          <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                          <path d="M7 7h.01" />
                        </svg>
                      </div>
                      <h3 className="mb-2 text-lg font-medium text-slate-800">Best Value</h3>
                      <p className="text-sm text-slate-600">
                        Enjoy competitive prices with group discounts and all-inclusive
                        packages
                      </p>
                    </div>
                    <div
                      className="rounded-lg border bg-card text-card-foreground shadow-sm p-6 text-center hover:shadow-md transition-all duration-300 reveal-on-scroll revealed"
                      style={{ transitionDelay: "200ms" }}
                    >
                      <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-star h-8 w-8 text-primary"
                        >
                          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                      </div>
                      <h3 className="mb-2 text-lg font-medium text-slate-800">
                        Curated Experiences
                      </h3>
                      <p className="text-sm text-slate-600">
                        Expertly planned itineraries covering must-see attractions and hidden
                        gems
                      </p>
                    </div>
                    <div
                      className="rounded-lg border bg-card text-card-foreground shadow-sm p-6 text-center hover:shadow-md transition-all duration-300 reveal-on-scroll revealed"
                      style={{ transitionDelay: "300ms" }}
                    >
                      <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-heart h-8 w-8 text-primary"
                        >
                          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                        </svg>
                      </div>
                      <h3 className="mb-2 text-lg font-medium text-slate-800">
                        Safe &amp; Supported
                      </h3>
                      <p className="text-sm text-slate-600">
                        Travel with experienced guides and 24/7 support throughout your
                        journey
                      </p>
                    </div>
                  </div>
                </div>
              </section>


              <section className="py-16 md:py-20 bg-gradient-to-br from-primary/10 via-secondary/10 to-primary/10 ">
                <div className="container mx-auto px-4 md:px-6 text-center reveal-on-scroll revealed">
                  <div className="max-w-3xl mx-auto">
                    <div className="inline-flex items-center gap-2 rounded-full bg-white/80 backdrop-blur-sm px-4 py-2 mb-6">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-4 w-4 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-sm font-medium text-slate-700">
                        Custom Trip Planning Available
                      </span>
                    </div>
                    <h2 className="mb-4 text-3xl md:text-4xl font-bold text-slate-900">
                      Can't Find the{" "}
                      <span className="bg-gradient-to-r text-primary to-secondary bg-clip-text">
                        Perfect Trip?
                      </span>
                    </h2>
                    <p className="mb-8 text-slate-600 text-lg max-w-2xl mx-auto">
                      Let us know your dream destination and we'll organize a group trip just
                      for you!
                    </p>
                    <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 h-10 bg-gradient-to-r from-primary to-primary/90 text-white hover:shadow-lg hover:shadow-primary/30 transition-all duration-300 hover:scale-105 px-8 py-6 text-base">
                      Request Custom Trip
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-arrow-right ml-2 h-5 w-5"
                      >
                        <path d="M5 12h14" />
                        <path d="m12 5 7 7-7 7" />
                      </svg>
                    </button>
                  </div>
                </div>
              </section>     

        
        {/* ./New Html code */}
      </main>
     </div>


      <div className="block sm:hidden">
        <div className="mobile-app-container">
        
      
            <main className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-50">
              <section className="relative overflow-hidden bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
                <div className="absolute inset-0 z-0">
                  <img
                    alt="Group Travel Adventures"
                    decoding="async"
                    data-nimg="fill"
                    className="object-cover object-center opacity-40"
                    style={{
                      position: "absolute",
                      height: "100%",
                      width: "100%",
                      inset: 0,
                      color: "transparent"
                    }}
                    src="/assets/images/group-travel-adventure-mountains.jpg"
                  />
                  <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />
                </div>
                <div className="md:hidden relative z-10 h-52 flex flex-col items-center justify-center px-5 py-5">
                  <div className="text-center space-y-1">
                    <h2 className="text-white text-sm font-semibold drop-shadow-lg tracking-wide">
                      UPCOMING
                    </h2>
                    <h2
                      className="text-yellow-400 text-3xl font-extrabold drop-shadow-lg"
                      style={{
                        textShadow: "rgba(0, 0, 0, 0.6) 3px 3px 8px",
                        fontFamily: "system-ui, -apple-system, sans-serif",
                        letterSpacing: "0.02em"
                      }}
                    >
                      Community
                    </h2>
                    <h2 className="text-white text-xl font-semibold drop-shadow-lg tracking-wide">
                      TRIPS
                    </h2>
                    <div className="flex items-center justify-center gap-3 mt-4">
                      <div className="flex items-center gap-1.5 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-md">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-star h-3.5 w-3.5 text-yellow-500 fill-yellow-500"
                        >
                          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                        <span className="text-xs font-bold text-slate-800">4.9</span>
                      </div>
                      <div className="flex items-center gap-1.5 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-md">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-users h-3.5 w-3.5 text-teal-600"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <circle cx={9} cy={7} r={4} />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                        <span className="text-xs font-bold text-slate-800">
                          2K+ Travelers
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="hidden md:block container relative z-10 mx-auto px-4 py-16 md:py-20">
                  <div className="max-w-3xl mx-auto text-center">
                    <div className="inline-flex items-center gap-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 px-4 py-2 mb-6">
                      <div className="h-2 w-2 rounded-full bg-green-400 animate-pulse" />
                      <span className="text-sm font-medium text-white">
                        Join 10,000+ Happy Travelers
                      </span>
                    </div>
                    <h1 className="font-bold text-white mb-4 leading-tight text-4xl md:text-5xl lg:text-6xl">
                      Discover Your Next
                      <span className="block bg-gradient-to-r from-white via-blue-100 to-purple-100 bg-clip-text text-transparent mt-2">
                        Group Adventure
                      </span>
                    </h1>
                    <p className="text-white/80 mb-8 leading-relaxed text-base md:text-lg max-w-2xl mx-auto">
                      Connect with fellow travelers and explore breathtaking
                      destinations together. From mountain treks to beach escapes,
                      find your perfect group trip.
                    </p>
                    <div className="grid grid-cols-3 gap-4 max-w-lg mx-auto">
                      <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-4">
                        <div className="text-2xl md:text-3xl font-bold text-white mb-1">
                          50+
                        </div>
                        <div className="text-xs md:text-sm text-white/70">
                          Destinations
                        </div>
                      </div>
                      <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-4">
                        <div className="text-2xl md:text-3xl font-bold text-white mb-1">
                          10K+
                        </div>
                        <div className="text-xs md:text-sm text-white/70">
                          Happy Travelers
                        </div>
                      </div>
                      <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-lg p-4">
                        <div className="text-2xl md:text-3xl font-bold text-white mb-1">
                          200+
                        </div>
                        <div className="text-xs md:text-sm text-white/70">
                          Group Trips
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>


              


              <div className="md:hidden bg-white border-b px-4 py-3.5">
                {accordionStates[1] && (
                 <div className="flex gap-2 custom-scroll pb-1">

                  {/* All Months */}
                  <button
                    onClick={() =>
                      setSelectedFilters((prev) => ({ ...prev, month: "All Months" }))
                    }
                    className={`px-3.5 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all ${
                      selectedFilters.month === "All Months"
                        ? "bg-teal-500 text-white shadow-md"
                        : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                    }`}
                  >
                    All Months
                  </button>

                  {/* Months List */}
                  {[
                    'January','February','March','April','May','June',
                    'July','August','September','October','November','December'
                  ].map((month) => (
                    <button
                      key={month}
                      onClick={() =>
                        setSelectedFilters((prev) => ({ ...prev, month }))
                      }
                      className={`px-3.5 py-1.5 rounded-full text-xs font-medium whitespace-nowrap transition-all ${
                        selectedFilters.month === month
                          ? "bg-teal-500 text-white shadow-md"
                          : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                      }`}
                    >
                      {month}
                    </button>
                  ))}

                    ))}
                 </div>
                )}
              </div>

              <section className="md:hidden bg-slate-50">
                <div className="bg-slate-50 border-b px-4 py-3">
                  <div className="flex gap-2 mb-3">
                  {accordionStates[0] && (
                    <div className="relative flex-[3]">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-search absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400 pointer-events-none z-10"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <path d="m21 21-4.3-4.3" />
                      </svg>
                      <input
                        placeholder="Search destinations..."
                        className="pl-10 pr-4 h-10 w-full bg-white border border-slate-200 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-teal-500 outline-none text-sm"
                        type="text"
                        defaultValue="" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  )}

                    <button onClick={() => setShowFilters(!showFilters)} className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 border border-input hover:text-accent-foreground rounded-md bg-white hover:bg-slate-50 h-10 px-4 flex-shrink-0">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-sliders h-4 w-4 mr-2"
                      >
                        <line x1={4} x2={4} y1={21} y2={14} />
                        <line x1={4} x2={4} y1={10} y2={3} />
                        <line x1={12} x2={12} y1={21} y2={12} />
                        <line x1={12} x2={12} y1={8} y2={3} />
                        <line x1={20} x2={20} y1={21} y2={16} />
                        <line x1={20} x2={20} y1={12} y2={3} />
                        <line x1={2} x2={6} y1={14} y2={14} />
                        <line x1={10} x2={14} y1={8} y2={8} />
                        <line x1={18} x2={22} y1={16} y2={16} />
                      </svg>
                      Filters
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-chevron-down h-4 w-4 ml-2 transition-transform "
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </button>
                  </div>
                  <div className="flex gap-2 scrollbar-custom pb-1 community-list">
                  {filters.destinations.map((dest) => (
                      <button
                          key={dest}
                          onClick={() => setSelectedFilters((prev) => ({ ...prev, destination: dest }))}
                          className={`px-4 py-2 rounded-lg text-sm font-medium ${
                            selectedFilters.destination === dest
                              ? "bg-gradient-to-r from-primary to-primary/90 text-white shadow-md"
                              : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                          }`}
                        >
                          {dest}
                        </button>
                    ))}
                  </div>


                  {/* New code */}
                  {showFilters && (
                  <div className="mt-3 space-y-4 bg-slate-50 rounded-lg p-4 filter-view">

                    
                    <div>
                      <h4 className="text-xs font-semibold text-slate-600 mb-2 uppercase">
                        Category
                      </h4>

                      <div className="flex flex-wrap gap-2">
                        {["All", "Adventure", "Nature", "Beach", "Cultural", "Luxury"].map((cat) => (
                          <button
                            key={cat}
                            onClick={() =>
                              setSelectedFilters((prev) => ({ ...prev, category: cat }))
                            }
                            className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
                              selectedFilters.category === cat
                                ? "bg-teal-600 text-white shadow-md"
                                : "bg-white text-slate-700 border border-slate-200 hover:bg-slate-100"
                            }`}
                          >
                            {cat}
                          </button>
                        ))}
                      </div>
                    </div>



                    <div>
                      <h4 className="text-xs font-semibold text-slate-600 mb-2 uppercase">
                        Budget
                      </h4>
                      <div className="flex flex-wrap gap-2">
                        <button
                          onClick={() =>
                            setSelectedFilters((prev) => ({ ...prev, budget: "All Budgets" }))
                          }
                          className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
                            selectedFilters.budget === "All Budgets"
                              ? "bg-teal-600 text-white shadow-md"
                              : "bg-white text-slate-700 hover:bg-slate-100 border border-slate-200"
                          }`}
                        >
                          All Budgets
                        </button>

                        {/* Budget Friendly */}
                        <button
                          onClick={() =>
                            setSelectedFilters((prev) => ({ ...prev, budget: "Budget Friendly" }))
                          }
                          className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
                            selectedFilters.budget === "Budget Friendly"
                              ? "bg-teal-600 text-white shadow-md"
                              : "bg-white text-slate-700 hover:bg-slate-100 border border-slate-200"
                          }`}
                        >
                          Budget Friendly
                        </button>

                        {/* Moderate */}
                        <button
                          onClick={() =>
                            setSelectedFilters((prev) => ({ ...prev, budget: "Moderate" }))
                          }
                          className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
                            selectedFilters.budget === "Moderate"
                              ? "bg-teal-600 text-white shadow-md"
                              : "bg-white text-slate-700 hover:bg-slate-100 border border-slate-200"
                          }`}
                        >
                          Moderate
                        </button>

                        {/* Premium */}
                        <button
                          onClick={() =>
                            setSelectedFilters((prev) => ({ ...prev, budget: "Premium" }))
                          }
                          className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${
                            selectedFilters.budget === "Premium"
                              ? "bg-teal-600 text-white shadow-md"
                              : "bg-white text-slate-700 hover:bg-slate-100 border border-slate-200"
                          }`}
                        >
                          Premium
                        </button>
                      </div>
                    </div>
                  </div>
                  )}

                  {/* ./New Code */}

                </div>



                <div className="px-4 pb-3 pt-2 bg-slate-50">
                  <div className="flex items-center justify-between mb-4 mt-4">
                    <p className="text-sm text-slate-600">{filteredTrips.length} trips found</p>
                  </div>
                  <div className="space-y-4 pb-0">

               {loading ? (
                <p className="text-center col-span-2">Loading trips...</p>
              ) : filteredTrips.length === 0 ? (
                <p className="text-center col-span-2">No trips found.</p>
              ) : (
                filteredTrips.map((trip) => (
                    <a key={trip.id} className="block mb-4" href={`/GroupTripsDtl/${trip.id}`}>
                      <div className="rounded-lg border bg-card text-card-foreground overflow-hidden shadow-sm">
                        <div className="relative h-44">
                          <img
                            alt={trip.name}
                            loading="lazy"
                            decoding="async"
                            data-nimg="fill"
                            className="object-cover"
                            style={{
                              position: "absolute",
                              height: "100%",
                              width: "100%",
                              inset: 0,
                              color: "transparent"
                            }}
                            src={
                              trip.images
                                ? `${API_BASE}${trip.images}`
                                : `${API_BASE}default.jpg`
                            }
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                          <div className="absolute bottom-3 left-3 right-3">
                            <h3 className="font-bold text-white text-base mb-1">
                              {trip.name}
                            </h3>
                            <div className="flex items-center gap-1 text-white/90 text-xs">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-map-pin h-3 w-3"
                              >
                                <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                <circle cx={12} cy={10} r={3} />
                              </svg>
                              <span>{trip.city}</span>
                            </div>
                          </div>
                        </div>
                        <div className="p-3">
                          <div className="mb-3">
                            <p className="text-xs text-slate-500 mb-1.5">
                              Available Dates:
                            </p>
                            <div className="flex gap-1.5 flex-wrap">
                               {(() => {
                                let tourDates = [];

                                try {
                                  tourDates = trip?.tour_date
                                    ? JSON.parse(trip.tour_date)
                                    : [];
                                } catch (e) {
                                  tourDates = [];
                                }

                                return (
                                  <>
                                    {tourDates.slice(0, 3).map((date, index) => {
                                      // Remove weekday (Tuesday / Friday)
                                      const cleanDate = date.split("-")[0].trim();

                                      return (
                                        <span
                                          key={index}
                                          className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md"
                                        >
                                          {cleanDate}
                                        </span>
                                      );
                                    })}

                                    {tourDates.length > 3 && (
                                      <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                        +{tourDates.length - 3} more
                                      </span>
                                    )}
                                  </>
                                );
                              })()}
                            </div>
                          </div>
                          <div className="flex items-center justify-between text-xs text-slate-600 mb-3">
                            <div className="flex items-center gap-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-calendar h-3 w-3"
                              >
                                <rect
                                  width={18}
                                  height={18}
                                  x={3}
                                  y={4}
                                  rx={2}
                                  ry={2}
                                />
                                <line x1={16} x2={16} y1={2} y2={6} />
                                <line x1={8} x2={8} y1={2} y2={6} />
                                <line x1={3} x2={21} y1={10} y2={10} />
                              </svg>
                              <span>{trip.duration} / {trip.no_of_days} days</span>
                            </div>
                            <div className="flex items-center gap-1">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-star h-3 w-3 text-yellow-500 fill-yellow-500"
                              >
                                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                              </svg>
                              <span className="font-semibold text-slate-900">
                                4.8
                              </span>
                              <span className="text-slate-500">(124)</span>
                            </div>
                          </div>
                          <div className="flex items-center justify-between">
                            <div>
                              <div className="flex items-baseline gap-1.5">
                                <span className="text-lg font-bold text-slate-900">
                                  ₹{trip.charges}
                                </span>
                                <span className="text-xs text-slate-500 line-through">
                                  ₹{trip.difficulties}
                                </span>
                              </div>
                             <p className="text-xs text-slate-500">per person</p>
                            </div>
                        {trip.spots && (
                            <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 border-transparent hover:bg-primary/80 bg-teal-50 text-teal-700 text-xs px-2 py-0.5 border-0">
                              {trip.spots} spots left
                            </div>
                         )}
                          </div>
                        </div>
                      </div>
                    </a>
                ))
                )}
                  </div>
                </div>
              </section>

              

              <section className="hidden md:block py-8 bg-white border-b border-slate-200">
                <div className="container mx-auto px-4">
                  <div className="mb-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="h-8 w-8 rounded-lg bg-primary/10 flex items-center justify-center">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-map-pin h-4 w-4 text-primary"
                        >
                          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                          <circle cx={12} cy={10} r={3} />
                        </svg>
                      </div>
                      <div>
                        <h3 className="text-base font-semibold text-slate-900">
                          Filter by Destination
                        </h3>
                        <p className="text-xs text-slate-500">
                          Select your preferred travel location
                        </p>
                      </div>
                    </div>
                    <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-2">
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-gradient-to-r from-primary to-primary/90 text-white shadow-md shadow-primary/30">
                        All
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Spiti Valley
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Meghalaya
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Himachal Pradesh
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Dubai
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Almaty
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Bhutan
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Bali
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Vietnam
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Russia
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Georgia
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Sri Lanka
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Japan
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Northern Lights
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Tirthan Valley
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Thailand
                      </button>
                      <button className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap bg-slate-100 text-slate-700 hover:bg-slate-200 hover:shadow-sm">
                        Philippines
                      </button>
                    </div>
                  </div>
                  <div className="flex flex-col lg:flex-row gap-6">
                    <div className="lg:w-64 space-y-3">
                      <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
                        <button className="w-full flex items-center justify-between p-3 hover:bg-slate-50 transition-colors">
                          <div className="flex items-center gap-2">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-search h-4 w-4 text-primary"
                            >
                              <circle cx={11} cy={11} r={8} />
                              <path d="m21 21-4.3-4.3" />
                            </svg>
                            <h3 className="text-sm font-semibold text-slate-900">
                              Search Trips
                            </h3>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-chevron-down h-4 w-4 text-slate-500 transition-transform duration-200 rotate-180"
                          >
                            <path d="m6 9 6 6 6-6" />
                          </svg>
                        </button>
                        <div className="px-3 pb-3">
                          <div className="relative">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-search absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400"
                            >
                              <circle cx={11} cy={11} r={8} />
                              <path d="m21 21-4.3-4.3" />
                            </svg>
                            <input
                              className="flex w-full rounded-md border bg-background px-3 py-2 ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pl-10 h-9 text-sm border-slate-200 focus:border-primary focus:ring-primary/20"
                              placeholder="Search trips..."
                              type="text"
                              defaultValue="" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
                        <button className="w-full flex items-center justify-between p-3 hover:bg-slate-50 transition-colors">
                          <div className="flex items-center gap-2">
                            <div className="h-7 w-7 rounded-lg bg-primary/10 flex items-center justify-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                              >
                                <rect
                                  width={18}
                                  height={18}
                                  x={3}
                                  y={4}
                                  rx={2}
                                  ry={2}
                                />
                                <line x1={16} x2={16} y1={2} y2={6} />
                                <line x1={8} x2={8} y1={2} y2={6} />
                                <line x1={3} x2={21} y1={10} y2={10} />
                              </svg>
                            </div>
                            <div className="text-left">
                              <h3 className="text-sm font-semibold text-slate-900">
                                Travel Month
                              </h3>
                            </div>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-chevron-down h-4 w-4 text-slate-500 transition-transform duration-200 rotate-180"
                          >
                            <path d="m6 9 6 6 6-6" />
                          </svg>
                        </button>
                        <div className="px-3 pb-3 space-y-1.5">
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-gradient-to-r from-primary to-primary/90 text-white shadow-sm">
                            All Months
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            January
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            February
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            March
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            April
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            May
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            June
                          </button>
                        </div>
                      </div>
                      <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
                        <button className="w-full flex items-center justify-between p-3 hover:bg-slate-50 transition-colors">
                          <div className="flex items-center gap-2">
                            <div className="h-7 w-7 rounded-lg bg-green-50 flex items-center justify-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-indian-rupee h-3.5 w-3.5 text-green-600"
                              >
                                <path d="M6 3h12" />
                                <path d="M6 8h12" />
                                <path d="m6 13 8.5 8" />
                                <path d="M6 13h3" />
                                <path d="M9 13c6.667 0 6.667-10 0-10" />
                              </svg>
                            </div>
                            <div className="text-left">
                              <h3 className="text-sm font-semibold text-slate-900">
                                Budget Range
                              </h3>
                            </div>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-chevron-down h-4 w-4 text-slate-500 transition-transform duration-200 rotate-180"
                          >
                            <path d="m6 9 6 6 6-6" />
                          </svg>
                        </button>
                        <div className="px-3 pb-3 space-y-1.5">
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-gradient-to-r from-green-500 to-green-600 text-white shadow-sm">
                            <div className="flex items-center justify-between">
                              <span>All Budgets</span>
                            </div>
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            <div className="flex items-center justify-between">
                              <span>Budget Friendly</span>
                              <span className="text-xs opacity-80">₹0K - ₹25K</span>
                            </div>
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            <div className="flex items-center justify-between">
                              <span>Moderate</span>
                              <span className="text-xs opacity-80">₹25K - ₹40K</span>
                            </div>
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            <div className="flex items-center justify-between">
                              <span>Premium</span>
                              <span className="text-xs opacity-80">₹40K+</span>
                            </div>
                          </button>
                        </div>
                      </div>
                      <div className="bg-white rounded-lg border border-slate-200 shadow-sm overflow-hidden">
                        <button className="w-full flex items-center justify-between p-3 hover:bg-slate-50 transition-colors">
                          <div className="flex items-center gap-2">
                            <div className="h-7 w-7 rounded-lg bg-purple-50 flex items-center justify-center">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-tag h-3.5 w-3.5 text-purple-600"
                              >
                                <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                <path d="M7 7h.01" />
                              </svg>
                            </div>
                            <div className="text-left">
                              <h3 className="text-sm font-semibold text-slate-900">
                                Trip Category
                              </h3>
                            </div>
                          </div>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-chevron-down h-4 w-4 text-slate-500 transition-transform duration-200 rotate-180"
                          >
                            <path d="m6 9 6 6 6-6" />
                          </svg>
                        </button>
                        <div className="px-3 pb-3 space-y-1.5">
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-gradient-to-r from-purple-500 to-purple-600 text-white shadow-sm">
                            All
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            Adventure
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            Nature
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            Beach
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            Cultural
                          </button>
                          <button className="w-full text-left px-3 py-2 rounded-md text-sm font-medium transition-all duration-200 bg-slate-50 text-slate-700 hover:bg-slate-100">
                            Luxury
                          </button>
                        </div>
                      </div>


                      <div className="bg-gradient-to-br from-primary/10 via-secondary/10 to-transparent rounded-lg border border-primary/20 p-4">
                        <div className="flex items-center gap-3">
                          <div className="h-9 w-9 rounded-lg bg-primary/20 flex items-center justify-center">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width={24}
                              height={24}
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={2}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="lucide lucide-sliders h-4 w-4 text-primary"
                            >
                              <line x1={4} x2={4} y1={21} y2={14} />
                              <line x1={4} x2={4} y1={10} y2={3} />
                              <line x1={12} x2={12} y1={21} y2={12} />
                              <line x1={12} x2={12} y1={8} y2={3} />
                              <line x1={20} x2={20} y1={21} y2={16} />
                              <line x1={20} x2={20} y1={12} y2={3} />
                              <line x1={2} x2={6} y1={14} y2={14} />
                              <line x1={10} x2={14} y1={8} y2={8} />
                              <line x1={18} x2={22} y1={16} y2={16} />
                            </svg>
                          </div>
                          <div>
                            <p className="text-xl font-bold text-slate-900">{filteredTrips.length}</p>
                            <p className="text-xs text-slate-600">Trips available</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className="grid gap-5 sm:grid-cols-2">
                        <div
                          className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/40 hover:shadow-xl reveal-on-scroll"
                          style={{ transitionDelay: "0ms" }}
                        >
                          <a href="/group-trips/1">
                            <div className="relative h-52 w-full overflow-hidden">
                              <img
                                alt="Winter Spiti 4x4 Expedition"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                className="object-cover transition-transform duration-500 group-hover:scale-110"
                                style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "100%",
                                  inset: 0,
                                  color: "transparent"
                                }}
                                src="/assets/images/coastal-mountain-vista.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                              <div className="absolute top-3 left-3 flex gap-2">
                                <div className="rounded-lg bg-gradient-to-r from-primary to-primary/90 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-white">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-tag h-3.5 w-3.5"
                                    >
                                      <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                      <path d="M7 7h.01" />
                                    </svg>
                                    Free Goodies
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="rounded-lg bg-white/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                                    >
                                      <rect
                                        width={18}
                                        height={18}
                                        x={3}
                                        y={4}
                                        rx={2}
                                        ry={2}
                                      />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                    6 nights / 7 days
                                  </p>
                                </div>
                              </div>
                              <div className="absolute bottom-0 left-0 right-0 p-4">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Adventure
                                  </div>
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Moderate
                                  </div>
                                </div>
                                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-200 transition-colors line-clamp-2">
                                  Winter Spiti 4x4 Expedition
                                </h3>
                                <div className="flex items-center justify-between text-xs text-white/90">
                                  <div className="flex items-center gap-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin h-3.5 w-3.5 text-blue-300"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span className="font-medium">Spiti Valley</span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <span className="font-semibold">4.8</span>
                                    <span className="text-white/70">(124)</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-baseline gap-2">
                                  <span className="text-xl font-bold text-slate-900">
                                    ₹36,999
                                  </span>
                                  <span className="text-sm text-slate-500 line-through">
                                    ₹41,999
                                  </span>
                                </div>
                                <span className="text-xs font-bold text-green-700 bg-green-100 px-2.5 py-1 rounded-lg">
                                  Save ₹5,000
                                </span>
                              </div>
                              <div className="mb-3 rounded-lg bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200 px-3 py-2 text-xs font-semibold text-orange-700 flex items-center gap-2">
                                <div className="h-2 w-2 rounded-full bg-orange-500 animate-pulse" />
                                Only 4 spots left!
                              </div>
                              <div className="flex items-start gap-2 text-slate-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-calendar h-4 w-4 text-primary mt-0.5 flex-shrink-0"
                                >
                                  <rect
                                    width={18}
                                    height={18}
                                    x={3}
                                    y={4}
                                    rx={2}
                                    ry={2}
                                  />
                                  <line x1={16} x2={16} y1={2} y2={6} />
                                  <line x1={8} x2={8} y1={2} y2={6} />
                                  <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                <div className="flex flex-wrap gap-1.5">
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 10
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 24
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Feb 7
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div
                          className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/40 hover:shadow-xl reveal-on-scroll"
                          style={{ transitionDelay: "50ms" }}
                        >
                          <a href="/group-trips/2">
                            <div className="relative h-52 w-full overflow-hidden">
                              <img
                                alt="Winter Spiti Trip"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                className="object-cover transition-transform duration-500 group-hover:scale-110"
                                style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "100%",
                                  inset: 0,
                                  color: "transparent"
                                }}
                                src="/assets/images/solo-mountain-vista.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                              <div className="absolute top-3 left-3 flex gap-2">
                                <div className="rounded-lg bg-gradient-to-r from-primary to-primary/90 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-white">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-tag h-3.5 w-3.5"
                                    >
                                      <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                      <path d="M7 7h.01" />
                                    </svg>
                                    Free Goodies
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="rounded-lg bg-white/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                                    >
                                      <rect
                                        width={18}
                                        height={18}
                                        x={3}
                                        y={4}
                                        rx={2}
                                        ry={2}
                                      />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                    6 nights / 7 days
                                  </p>
                                </div>
                              </div>
                              <div className="absolute bottom-0 left-0 right-0 p-4">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Adventure
                                  </div>
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Easy
                                  </div>
                                </div>
                                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-200 transition-colors line-clamp-2">
                                  Winter Spiti Trip
                                </h3>
                                <div className="flex items-center justify-between text-xs text-white/90">
                                  <div className="flex items-center gap-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin h-3.5 w-3.5 text-blue-300"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span className="font-medium">Spiti Valley</span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <span className="font-semibold">4.6</span>
                                    <span className="text-white/70">(89)</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-baseline gap-2">
                                  <span className="text-xl font-bold text-slate-900">
                                    ₹18,999
                                  </span>
                                  <span className="text-sm text-slate-500 line-through">
                                    ₹20,999
                                  </span>
                                </div>
                                <span className="text-xs font-bold text-green-700 bg-green-100 px-2.5 py-1 rounded-lg">
                                  Save ₹2,000
                                </span>
                              </div>
                              <div className="flex items-start gap-2 text-slate-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-calendar h-4 w-4 text-primary mt-0.5 flex-shrink-0"
                                >
                                  <rect
                                    width={18}
                                    height={18}
                                    x={3}
                                    y={4}
                                    rx={2}
                                    ry={2}
                                  />
                                  <line x1={16} x2={16} y1={2} y2={6} />
                                  <line x1={8} x2={8} y1={2} y2={6} />
                                  <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                <div className="flex flex-wrap gap-1.5">
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 10
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 17
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 24
                                  </span>
                                  <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                    +2 more
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div
                          className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/40 hover:shadow-xl reveal-on-scroll"
                          style={{ transitionDelay: "100ms" }}
                        >
                          <a href="/group-trips/3">
                            <div className="relative h-52 w-full overflow-hidden">
                              <img
                                alt="Meghalaya Backpacking - 6 Days Road Trip"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                className="object-cover transition-transform duration-500 group-hover:scale-110"
                                style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "100%",
                                  inset: 0,
                                  color: "transparent"
                                }}
                                src="/assets/images/coastal-mountain-vista.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                              <div className="absolute top-3 left-3 flex gap-2">
                                <div className="rounded-lg bg-gradient-to-r from-primary to-primary/90 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-white">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-tag h-3.5 w-3.5"
                                    >
                                      <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                      <path d="M7 7h.01" />
                                    </svg>
                                    Free Goodies
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="rounded-lg bg-white/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                                    >
                                      <rect
                                        width={18}
                                        height={18}
                                        x={3}
                                        y={4}
                                        rx={2}
                                        ry={2}
                                      />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                    5 nights / 6 days
                                  </p>
                                </div>
                              </div>
                              <div className="absolute bottom-0 left-0 right-0 p-4">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Nature
                                  </div>
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Moderate
                                  </div>
                                </div>
                                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-200 transition-colors line-clamp-2">
                                  Meghalaya Backpacking - 6 Days Road Trip
                                </h3>
                                <div className="flex items-center justify-between text-xs text-white/90">
                                  <div className="flex items-center gap-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin h-3.5 w-3.5 text-blue-300"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span className="font-medium">Meghalaya</span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <span className="font-semibold">4.9</span>
                                    <span className="text-white/70">(156)</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-baseline gap-2">
                                  <span className="text-xl font-bold text-slate-900">
                                    ₹22,999
                                  </span>
                                  <span className="text-sm text-slate-500 line-through">
                                    ₹24,999
                                  </span>
                                </div>
                                <span className="text-xs font-bold text-green-700 bg-green-100 px-2.5 py-1 rounded-lg">
                                  Save ₹2,000
                                </span>
                              </div>
                              <div className="flex items-start gap-2 text-slate-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-calendar h-4 w-4 text-primary mt-0.5 flex-shrink-0"
                                >
                                  <rect
                                    width={18}
                                    height={18}
                                    x={3}
                                    y={4}
                                    rx={2}
                                    ry={2}
                                  />
                                  <line x1={16} x2={16} y1={2} y2={6} />
                                  <line x1={8} x2={8} y1={2} y2={6} />
                                  <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                <div className="flex flex-wrap gap-1.5">
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 10
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 17
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 24
                                  </span>
                                  <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                    +3 more
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div
                          className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/40 hover:shadow-xl reveal-on-scroll"
                          style={{ transitionDelay: "150ms" }}
                        >
                          <a href="/group-trips/4">
                            <div className="relative h-52 w-full overflow-hidden">
                              <img
                                alt="Himachal Short Circuit 4N 5D"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                className="object-cover transition-transform duration-500 group-hover:scale-110"
                                style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "100%",
                                  inset: 0,
                                  color: "transparent"
                                }}
                                src="/assets/images/solo-mountain-vista.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                              <div className="absolute top-3 left-3 flex gap-2">
                                <div className="rounded-lg bg-gradient-to-r from-primary to-primary/90 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-white">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-tag h-3.5 w-3.5"
                                    >
                                      <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                      <path d="M7 7h.01" />
                                    </svg>
                                    Free Goodies
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="rounded-lg bg-white/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                                    >
                                      <rect
                                        width={18}
                                        height={18}
                                        x={3}
                                        y={4}
                                        rx={2}
                                        ry={2}
                                      />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                    4 nights / 5 days
                                  </p>
                                </div>
                              </div>
                              <div className="absolute bottom-0 left-0 right-0 p-4">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Adventure
                                  </div>
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Easy
                                  </div>
                                </div>
                                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-200 transition-colors line-clamp-2">
                                  Himachal Short Circuit 4N 5D
                                </h3>
                                <div className="flex items-center justify-between text-xs text-white/90">
                                  <div className="flex items-center gap-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin h-3.5 w-3.5 text-blue-300"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span className="font-medium">
                                      Himachal Pradesh
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <span className="font-semibold">4.7</span>
                                    <span className="text-white/70">(98)</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-baseline gap-2">
                                  <span className="text-xl font-bold text-slate-900">
                                    ₹17,999
                                  </span>
                                  <span className="text-sm text-slate-500 line-through">
                                    ₹18,999
                                  </span>
                                </div>
                                <span className="text-xs font-bold text-green-700 bg-green-100 px-2.5 py-1 rounded-lg">
                                  Save ₹1,000
                                </span>
                              </div>
                              <div className="flex items-start gap-2 text-slate-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-calendar h-4 w-4 text-primary mt-0.5 flex-shrink-0"
                                >
                                  <rect
                                    width={18}
                                    height={18}
                                    x={3}
                                    y={4}
                                    rx={2}
                                    ry={2}
                                  />
                                  <line x1={16} x2={16} y1={2} y2={6} />
                                  <line x1={8} x2={8} y1={2} y2={6} />
                                  <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                <div className="flex flex-wrap gap-1.5">
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 8
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 15
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 22
                                  </span>
                                  <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                    +3 more
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div
                          className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/40 hover:shadow-xl reveal-on-scroll"
                          style={{ transitionDelay: "200ms" }}
                        >
                          <a href="/group-trips/5">
                            <div className="relative h-52 w-full overflow-hidden">
                              <img
                                alt="Bali Paradise Retreat"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                className="object-cover transition-transform duration-500 group-hover:scale-110"
                                style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "100%",
                                  inset: 0,
                                  color: "transparent"
                                }}
                                src="/assets/images/coastal-mountain-vista.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                              <div className="absolute top-3 left-3 flex gap-2">
                                <div className="rounded-lg bg-gradient-to-r from-primary to-primary/90 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-white">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-tag h-3.5 w-3.5"
                                    >
                                      <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                      <path d="M7 7h.01" />
                                    </svg>
                                    Free Goodies
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="rounded-lg bg-white/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                                    >
                                      <rect
                                        width={18}
                                        height={18}
                                        x={3}
                                        y={4}
                                        rx={2}
                                        ry={2}
                                      />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                    7 nights / 8 days
                                  </p>
                                </div>
                              </div>
                              <div className="absolute bottom-0 left-0 right-0 p-4">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Beach
                                  </div>
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Easy
                                  </div>
                                </div>
                                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-200 transition-colors line-clamp-2">
                                  Bali Paradise Retreat
                                </h3>
                                <div className="flex items-center justify-between text-xs text-white/90">
                                  <div className="flex items-center gap-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin h-3.5 w-3.5 text-blue-300"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span className="font-medium">Bali</span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <span className="font-semibold">4.9</span>
                                    <span className="text-white/70">(201)</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-baseline gap-2">
                                  <span className="text-xl font-bold text-slate-900">
                                    ₹45,999
                                  </span>
                                  <span className="text-sm text-slate-500 line-through">
                                    ₹49,999
                                  </span>
                                </div>
                                <span className="text-xs font-bold text-green-700 bg-green-100 px-2.5 py-1 rounded-lg">
                                  Save ₹4,000
                                </span>
                              </div>
                              <div className="mb-3 rounded-lg bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200 px-3 py-2 text-xs font-semibold text-orange-700 flex items-center gap-2">
                                <div className="h-2 w-2 rounded-full bg-orange-500 animate-pulse" />
                                Only 3 spots left!
                              </div>
                              <div className="flex items-start gap-2 text-slate-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-calendar h-4 w-4 text-primary mt-0.5 flex-shrink-0"
                                >
                                  <rect
                                    width={18}
                                    height={18}
                                    x={3}
                                    y={4}
                                    rx={2}
                                    ry={2}
                                  />
                                  <line x1={16} x2={16} y1={2} y2={6} />
                                  <line x1={8} x2={8} y1={2} y2={6} />
                                  <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                <div className="flex flex-wrap gap-1.5">
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 15
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Feb 5
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Feb 20
                                  </span>
                                  <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                    +2 more
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div
                          className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/40 hover:shadow-xl reveal-on-scroll"
                          style={{ transitionDelay: "250ms" }}
                        >
                          <a href="/group-trips/6">
                            <div className="relative h-52 w-full overflow-hidden">
                              <img
                                alt="Dubai Desert Safari & City Tour"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                className="object-cover transition-transform duration-500 group-hover:scale-110"
                                style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "100%",
                                  inset: 0,
                                  color: "transparent"
                                }}
                                src="/assets/images/coastal-mountain-vista.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                              <div className="absolute top-3 left-3 flex gap-2">
                                <div className="rounded-lg bg-gradient-to-r from-primary to-primary/90 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-white">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-tag h-3.5 w-3.5"
                                    >
                                      <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                      <path d="M7 7h.01" />
                                    </svg>
                                    Free Goodies
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="rounded-lg bg-white/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                                    >
                                      <rect
                                        width={18}
                                        height={18}
                                        x={3}
                                        y={4}
                                        rx={2}
                                        ry={2}
                                      />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                    5 nights / 6 days
                                  </p>
                                </div>
                              </div>
                              <div className="absolute bottom-0 left-0 right-0 p-4">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Luxury
                                  </div>
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Easy
                                  </div>
                                </div>
                                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-200 transition-colors line-clamp-2">
                                  Dubai Desert Safari &amp; City Tour
                                </h3>
                                <div className="flex items-center justify-between text-xs text-white/90">
                                  <div className="flex items-center gap-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin h-3.5 w-3.5 text-blue-300"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span className="font-medium">Dubai</span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <span className="font-semibold">4.8</span>
                                    <span className="text-white/70">(143)</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-baseline gap-2">
                                  <span className="text-xl font-bold text-slate-900">
                                    ₹52,999
                                  </span>
                                  <span className="text-sm text-slate-500 line-through">
                                    ₹57,999
                                  </span>
                                </div>
                                <span className="text-xs font-bold text-green-700 bg-green-100 px-2.5 py-1 rounded-lg">
                                  Save ₹5,000
                                </span>
                              </div>
                              <div className="mb-3 rounded-lg bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200 px-3 py-2 text-xs font-semibold text-orange-700 flex items-center gap-2">
                                <div className="h-2 w-2 rounded-full bg-orange-500 animate-pulse" />
                                Only 5 spots left!
                              </div>
                              <div className="flex items-start gap-2 text-slate-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-calendar h-4 w-4 text-primary mt-0.5 flex-shrink-0"
                                >
                                  <rect
                                    width={18}
                                    height={18}
                                    x={3}
                                    y={4}
                                    rx={2}
                                    ry={2}
                                  />
                                  <line x1={16} x2={16} y1={2} y2={6} />
                                  <line x1={8} x2={8} y1={2} y2={6} />
                                  <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                <div className="flex flex-wrap gap-1.5">
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 12
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 26
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Feb 9
                                  </span>
                                  <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                    +2 more
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div
                          className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/40 hover:shadow-xl reveal-on-scroll"
                          style={{ transitionDelay: "300ms" }}
                        >
                          <a href="/group-trips/7">
                            <div className="relative h-52 w-full overflow-hidden">
                              <img
                                alt="Bhutan Cultural Journey"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                className="object-cover transition-transform duration-500 group-hover:scale-110"
                                style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "100%",
                                  inset: 0,
                                  color: "transparent"
                                }}
                                src="/assets/images/solo-mountain-vista.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                              <div className="absolute top-3 left-3 flex gap-2">
                                <div className="rounded-lg bg-gradient-to-r from-primary to-primary/90 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-white">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-tag h-3.5 w-3.5"
                                    >
                                      <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                      <path d="M7 7h.01" />
                                    </svg>
                                    Free Goodies
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="rounded-lg bg-white/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                                    >
                                      <rect
                                        width={18}
                                        height={18}
                                        x={3}
                                        y={4}
                                        rx={2}
                                        ry={2}
                                      />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                    6 nights / 7 days
                                  </p>
                                </div>
                              </div>
                              <div className="absolute bottom-0 left-0 right-0 p-4">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Cultural
                                  </div>
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Moderate
                                  </div>
                                </div>
                                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-200 transition-colors line-clamp-2">
                                  Bhutan Cultural Journey
                                </h3>
                                <div className="flex items-center justify-between text-xs text-white/90">
                                  <div className="flex items-center gap-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin h-3.5 w-3.5 text-blue-300"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span className="font-medium">Bhutan</span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <span className="font-semibold">4.9</span>
                                    <span className="text-white/70">(167)</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-baseline gap-2">
                                  <span className="text-xl font-bold text-slate-900">
                                    ₹38,999
                                  </span>
                                  <span className="text-sm text-slate-500 line-through">
                                    ₹42,999
                                  </span>
                                </div>
                                <span className="text-xs font-bold text-green-700 bg-green-100 px-2.5 py-1 rounded-lg">
                                  Save ₹4,000
                                </span>
                              </div>
                              <div className="mb-3 rounded-lg bg-gradient-to-r from-orange-50 to-red-50 border border-orange-200 px-3 py-2 text-xs font-semibold text-orange-700 flex items-center gap-2">
                                <div className="h-2 w-2 rounded-full bg-orange-500 animate-pulse" />
                                Only 4 spots left!
                              </div>
                              <div className="flex items-start gap-2 text-slate-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-calendar h-4 w-4 text-primary mt-0.5 flex-shrink-0"
                                >
                                  <rect
                                    width={18}
                                    height={18}
                                    x={3}
                                    y={4}
                                    rx={2}
                                    ry={2}
                                  />
                                  <line x1={16} x2={16} y1={2} y2={6} />
                                  <line x1={8} x2={8} y1={2} y2={6} />
                                  <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                <div className="flex flex-wrap gap-1.5">
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 20
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Feb 3
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Feb 17
                                  </span>
                                  <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                    +2 more
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div
                          className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/40 hover:shadow-xl reveal-on-scroll"
                          style={{ transitionDelay: "350ms" }}
                        >
                          <a href="/group-trips/8">
                            <div className="relative h-52 w-full overflow-hidden">
                              <img
                                alt="Vietnam Explorer - North to South"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                className="object-cover transition-transform duration-500 group-hover:scale-110"
                                style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "100%",
                                  inset: 0,
                                  color: "transparent"
                                }}
                                src="/assets/images/coastal-mountain-vista.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                              <div className="absolute top-3 left-3 flex gap-2">
                                <div className="rounded-lg bg-gradient-to-r from-primary to-primary/90 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-white">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-tag h-3.5 w-3.5"
                                    >
                                      <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                      <path d="M7 7h.01" />
                                    </svg>
                                    Free Goodies
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="rounded-lg bg-white/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                                    >
                                      <rect
                                        width={18}
                                        height={18}
                                        x={3}
                                        y={4}
                                        rx={2}
                                        ry={2}
                                      />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                    9 nights / 10 days
                                  </p>
                                </div>
                              </div>
                              <div className="absolute bottom-0 left-0 right-0 p-4">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Cultural
                                  </div>
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Easy
                                  </div>
                                </div>
                                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-200 transition-colors line-clamp-2">
                                  Vietnam Explorer - North to South
                                </h3>
                                <div className="flex items-center justify-between text-xs text-white/90">
                                  <div className="flex items-center gap-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin h-3.5 w-3.5 text-blue-300"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span className="font-medium">Vietnam</span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <span className="font-semibold">4.8</span>
                                    <span className="text-white/70">(189)</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-baseline gap-2">
                                  <span className="text-xl font-bold text-slate-900">
                                    ₹48,999
                                  </span>
                                  <span className="text-sm text-slate-500 line-through">
                                    ₹53,999
                                  </span>
                                </div>
                                <span className="text-xs font-bold text-green-700 bg-green-100 px-2.5 py-1 rounded-lg">
                                  Save ₹5,000
                                </span>
                              </div>
                              <div className="flex items-start gap-2 text-slate-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-calendar h-4 w-4 text-primary mt-0.5 flex-shrink-0"
                                >
                                  <rect
                                    width={18}
                                    height={18}
                                    x={3}
                                    y={4}
                                    rx={2}
                                    ry={2}
                                  />
                                  <line x1={16} x2={16} y1={2} y2={6} />
                                  <line x1={8} x2={8} y1={2} y2={6} />
                                  <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                <div className="flex flex-wrap gap-1.5">
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 18
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Feb 1
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Feb 15
                                  </span>
                                  <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                    +2 more
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div
                          className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/40 hover:shadow-xl reveal-on-scroll"
                          style={{ transitionDelay: "400ms" }}
                        >
                          <a href="/group-trips/9">
                            <div className="relative h-52 w-full overflow-hidden">
                              <img
                                alt="Sri Lanka Island Adventure"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                className="object-cover transition-transform duration-500 group-hover:scale-110"
                                style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "100%",
                                  inset: 0,
                                  color: "transparent"
                                }}
                                src="/assets/images/solo-mountain-vista.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                              <div className="absolute top-3 left-3 flex gap-2">
                                <div className="rounded-lg bg-gradient-to-r from-primary to-primary/90 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-white">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-tag h-3.5 w-3.5"
                                    >
                                      <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                      <path d="M7 7h.01" />
                                    </svg>
                                    Free Goodies
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="rounded-lg bg-white/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                                    >
                                      <rect
                                        width={18}
                                        height={18}
                                        x={3}
                                        y={4}
                                        rx={2}
                                        ry={2}
                                      />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                    7 nights / 8 days
                                  </p>
                                </div>
                              </div>
                              <div className="absolute bottom-0 left-0 right-0 p-4">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Nature
                                  </div>
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Moderate
                                  </div>
                                </div>
                                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-200 transition-colors line-clamp-2">
                                  Sri Lanka Island Adventure
                                </h3>
                                <div className="flex items-center justify-between text-xs text-white/90">
                                  <div className="flex items-center gap-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin h-3.5 w-3.5 text-blue-300"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span className="font-medium">Sri Lanka</span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <span className="font-semibold">4.7</span>
                                    <span className="text-white/70">(134)</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-baseline gap-2">
                                  <span className="text-xl font-bold text-slate-900">
                                    ₹32,999
                                  </span>
                                  <span className="text-sm text-slate-500 line-through">
                                    ₹36,999
                                  </span>
                                </div>
                                <span className="text-xs font-bold text-green-700 bg-green-100 px-2.5 py-1 rounded-lg">
                                  Save ₹4,000
                                </span>
                              </div>
                              <div className="flex items-start gap-2 text-slate-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-calendar h-4 w-4 text-primary mt-0.5 flex-shrink-0"
                                >
                                  <rect
                                    width={18}
                                    height={18}
                                    x={3}
                                    y={4}
                                    rx={2}
                                    ry={2}
                                  />
                                  <line x1={16} x2={16} y1={2} y2={6} />
                                  <line x1={8} x2={8} y1={2} y2={6} />
                                  <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                <div className="flex flex-wrap gap-1.5">
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 14
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 28
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Feb 11
                                  </span>
                                  <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                    +2 more
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div
                          className="text-card-foreground group overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:border-primary/40 hover:shadow-xl reveal-on-scroll"
                          style={{ transitionDelay: "450ms" }}
                        >
                          <a href="/group-trips/10">
                            <div className="relative h-52 w-full overflow-hidden">
                              <img
                                alt="Thailand Beach Hopping"
                                loading="lazy"
                                decoding="async"
                                data-nimg="fill"
                                className="object-cover transition-transform duration-500 group-hover:scale-110"
                                style={{
                                  position: "absolute",
                                  height: "100%",
                                  width: "100%",
                                  inset: 0,
                                  color: "transparent"
                                }}
                                src="/assets/images/coastal-mountain-vista.png"
                              />
                              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent" />
                              <div className="absolute top-3 left-3 flex gap-2">
                                <div className="rounded-lg bg-gradient-to-r from-primary to-primary/90 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-white">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-tag h-3.5 w-3.5"
                                    >
                                      <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                                      <path d="M7 7h.01" />
                                    </svg>
                                    Free Goodies
                                  </p>
                                </div>
                              </div>
                              <div className="absolute top-3 right-3">
                                <div className="rounded-lg bg-white/95 px-3 py-1.5 shadow-lg backdrop-blur-sm">
                                  <p className="flex items-center gap-1.5 text-xs font-semibold text-slate-800">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-calendar h-3.5 w-3.5 text-primary"
                                    >
                                      <rect
                                        width={18}
                                        height={18}
                                        x={3}
                                        y={4}
                                        rx={2}
                                        ry={2}
                                      />
                                      <line x1={16} x2={16} y1={2} y2={6} />
                                      <line x1={8} x2={8} y1={2} y2={6} />
                                      <line x1={3} x2={21} y1={10} y2={10} />
                                    </svg>
                                    8 nights / 9 days
                                  </p>
                                </div>
                              </div>
                              <div className="absolute bottom-0 left-0 right-0 p-4">
                                <div className="flex items-center gap-2 mb-2">
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Beach
                                  </div>
                                  <div className="inline-flex items-center rounded-full font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 hover:bg-primary/80 bg-white/20 backdrop-blur-md text-white border border-white/30 text-xs px-2.5 py-1">
                                    Easy
                                  </div>
                                </div>
                                <h3 className="text-lg font-bold text-white mb-2 group-hover:text-blue-200 transition-colors line-clamp-2">
                                  Thailand Beach Hopping
                                </h3>
                                <div className="flex items-center justify-between text-xs text-white/90">
                                  <div className="flex items-center gap-1.5">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-map-pin h-3.5 w-3.5 text-blue-300"
                                    >
                                      <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                                      <circle cx={12} cy={10} r={3} />
                                    </svg>
                                    <span className="font-medium">Thailand</span>
                                  </div>
                                  <div className="flex items-center gap-1">
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width={24}
                                      height={24}
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth={2}
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      className="lucide lucide-star h-3.5 w-3.5 text-yellow-400 fill-yellow-400"
                                    >
                                      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                                    </svg>
                                    <span className="font-semibold">4.8</span>
                                    <span className="text-white/70">(124)</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-4">
                              <div className="flex items-center justify-between mb-3">
                                <div className="flex items-baseline gap-2">
                                  <span className="text-xl font-bold text-slate-900">
                                    ₹41,999
                                  </span>
                                  <span className="text-sm text-slate-500 line-through">
                                    ₹45,999
                                  </span>
                                </div>
                                <span className="text-xs font-bold text-green-700 bg-green-100 px-2.5 py-1 rounded-lg">
                                  Save ₹4,000
                                </span>
                              </div>
                              <div className="flex items-start gap-2 text-slate-600">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={24}
                                  height={24}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth={2}
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  className="lucide lucide-calendar h-4 w-4 text-primary mt-0.5 flex-shrink-0"
                                >
                                  <rect
                                    width={18}
                                    height={18}
                                    x={3}
                                    y={4}
                                    rx={2}
                                    ry={2}
                                  />
                                  <line x1={16} x2={16} y1={2} y2={6} />
                                  <line x1={8} x2={8} y1={2} y2={6} />
                                  <line x1={3} x2={21} y1={10} y2={10} />
                                </svg>
                                <div className="flex flex-wrap gap-1.5">
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 14
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Jan 28
                                  </span>
                                  <span className="text-xs font-medium bg-slate-100 hover:bg-slate-200 transition-colors px-2 py-1 rounded-md">
                                    Feb 11
                                  </span>
                                  <span className="text-xs font-semibold text-primary bg-primary/10 px-2 py-1 rounded-md">
                                    +2 more
                                  </span>
                                </div>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>


        
              <section className="py-12 md:py-16 bg-white">
                <div className="container mx-auto px-4 md:px-6">
                  <div className="text-center mb-8 md:mb-12 reveal-on-scroll revealed">
                    <h2 className="mb-3 text-2xl md:text-3xl font-bold text-slate-800">
                      Why Choose <span className="text-gradient">Group Trips?</span>
                    </h2>
                    <p className="text-slate-600 max-w-2xl mx-auto">
                      Travel with confidence and make lifelong friends on our carefully
                      curated group adventures
                    </p>
                  </div>
                  <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-4">
                    <div
                      className="rounded-lg border bg-card text-card-foreground shadow-sm p-6 text-center hover:shadow-md transition-all duration-300 reveal-on-scroll revealed"
                      style={{ transitionDelay: "0ms" }}
                    >
                      <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-users h-8 w-8 text-primary"
                        >
                          <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                          <circle cx={9} cy={7} r={4} />
                          <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                      </div>
                      <h3 className="mb-2 text-lg font-medium text-slate-800">
                        Meet Like-Minded People
                      </h3>
                      <p className="text-sm text-slate-600">
                        Connect with fellow travelers who share your passion for exploration
                      </p>
                    </div>
                    <div
                      className="rounded-lg border bg-card text-card-foreground shadow-sm p-6 text-center hover:shadow-md transition-all duration-300 reveal-on-scroll revealed"
                      style={{ transitionDelay: "100ms" }}
                    >
                      <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-tag h-8 w-8 text-primary"
                        >
                          <path d="M12 2H2v10l9.29 9.29c.94.94 2.48.94 3.42 0l6.58-6.58c.94-.94.94-2.48 0-3.42L12 2Z" />
                          <path d="M7 7h.01" />
                        </svg>
                      </div>
                      <h3 className="mb-2 text-lg font-medium text-slate-800">Best Value</h3>
                      <p className="text-sm text-slate-600">
                        Enjoy competitive prices with group discounts and all-inclusive
                        packages
                      </p>
                    </div>
                    <div
                      className="rounded-lg border bg-card text-card-foreground shadow-sm p-6 text-center hover:shadow-md transition-all duration-300 reveal-on-scroll revealed"
                      style={{ transitionDelay: "200ms" }}
                    >
                      <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-star h-8 w-8 text-primary"
                        >
                          <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                        </svg>
                      </div>
                      <h3 className="mb-2 text-lg font-medium text-slate-800">
                        Curated Experiences
                      </h3>
                      <p className="text-sm text-slate-600">
                        Expertly planned itineraries covering must-see attractions and hidden
                        gems
                      </p>
                    </div>
                    <div
                      className="rounded-lg border bg-card text-card-foreground shadow-sm p-6 text-center hover:shadow-md transition-all duration-300 reveal-on-scroll revealed"
                      style={{ transitionDelay: "300ms" }}
                    >
                      <div className="mb-4 inline-flex h-16 w-16 items-center justify-center rounded-full bg-primary/10">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width={24}
                          height={24}
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="lucide lucide-heart h-8 w-8 text-primary"
                        >
                          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                        </svg>
                      </div>
                      <h3 className="mb-2 text-lg font-medium text-slate-800">
                        Safe &amp; Supported
                      </h3>
                      <p className="text-sm text-slate-600">
                        Travel with experienced guides and 24/7 support throughout your
                        journey
                      </p>
                    </div>
                  </div>
                </div>
              </section>


              <section className="py-16 md:py-20 bg-gradient-to-br from-primary/10 via-secondary/10 to-primary/10 mb-10">
                <div className="container mx-auto px-4 md:px-6 text-center reveal-on-scroll revealed">
                  <div className="max-w-3xl mx-auto">
                    <div className="inline-flex items-center gap-2 rounded-full bg-white/80 backdrop-blur-sm px-4 py-2 mb-6">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-heart h-4 w-4 text-primary"
                      >
                        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
                      </svg>
                      <span className="text-sm font-medium text-slate-700">
                        Custom Trip Planning Available
                      </span>
                    </div>
                    <h2 className="mb-4 text-3xl md:text-4xl font-bold text-slate-900">
                      Can't Find the{" "}
                      <span className="text-gradient">
                        Perfect Trip?
                      </span>
                    </h2>
                    <p className="mb-8 text-slate-600 text-lg max-w-2xl mx-auto">
                      Let us know your dream destination and we'll organize a group trip just
                      for you!
                    </p>
                    <button className="inline-flex items-center justify-center whitespace-nowrap rounded-md font-medium ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary hover:bg-primary/90 h-10 bg-gradient-to-r from-primary to-primary/90 text-white hover:shadow-lg hover:shadow-primary/30 transition-all duration-300 hover:scale-105 px-8 py-6 text-base">
                      Request Custom Trip
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-arrow-right ml-2 h-5 w-5"
                      >
                        <path d="M5 12h14" />
                        <path d="m12 5 7 7-7 7" />
                      </svg>
                    </button>
                  </div>
                </div>
              </section>



          

            </main>
    
          
        </div>
      </div>


      <Footer />
    </>
  );
};

export default GroupTrips;